export default "/_next/static/chunks/fonts/Channel4Horseferry-Bold-5c2bc3676e8cec0182fae1ccd56e4981.woff2";